export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-hero-811a8d50f1cc490214fc4412626b3f1c.jpg";